/* eslint-disable no-restricted-syntax */
import moment from 'moment';
import set from 'lodash/set';

import { useImportDocumentStore } from '../../../../store';
import { IMPORT_DOCUMENT_VALUES_FORMAT_RULES } from '../../../../constants/importDocuments';

import {
  formatCurrency,
  unformatCurrency,
} from '../../../../helpers/currencyMask';
import { removeGroupFromField } from '../../helpers/groupResultFields';

const findValue = (obj, targetKey) => {
  for (const key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (!obj.hasOwnProperty(key)) {
      // eslint-disable-next-line no-continue
      continue;
    }

    if (key === targetKey) {
      return obj[key];
    }

    if (typeof obj[key] === 'object' && obj[key] !== null) {
      const result = findValue(obj[key], targetKey);

      if (result) {
        return result;
      }
    }
  }

  // Return null if the key is not found anywhere in the object
  return null;
};

export const getFieldType = (key) => {
  const rule = IMPORT_DOCUMENT_VALUES_FORMAT_RULES[key];

  if (typeof rule === 'object' && rule !== null) {
    return rule;
  }

  if (['percentage', 'currency', 'date', 'select'].includes(rule)) {
    return rule;
  }
  return 'text';
};

export const formatField = (key, value) => {
  const rule = IMPORT_DOCUMENT_VALUES_FORMAT_RULES[key];

  const { selectedBorrower } = useImportDocumentStore.getState();
  if (key === 'borrower' && selectedBorrower) {
    return selectedBorrower.name;
  }

  const { selectedCoborrower } = useImportDocumentStore.getState();
  if (key === 'coborrower' && selectedCoborrower) {
    return selectedCoborrower.name;
  }

  if (!rule) {
    return value;
  }

  if (typeof rule === 'function') {
    return rule(value);
  }

  if (rule === 'hidden') {
    return null;
  }

  switch (rule) {
    case 'percentage':
      return `${(value * 100).toFixed(2)}%`;
    case 'currency':
      return `$${formatCurrency(value)}`;
    case 'date':
      return moment(value).format('M/D/YY');
    default:
      return value;
  }
};

export const formatDocumentForUpdate = (newValue, fullKey, type, document) => {
  const keyWithoutGroup = removeGroupFromField(fullKey);

  const documentCopy = JSON.parse(JSON.stringify(document));

  const documentWithNewValue = {
    ...documentCopy,
    parseur_result: { ...documentCopy.parseur_result },
  };

  let formattedNewValue = newValue;

  if (type === 'currency') {
    formattedNewValue = unformatCurrency(newValue);
  } else if (type === 'percentage') {
    formattedNewValue = newValue / 100;
  } else if (type === 'date') {
    [formattedNewValue] = newValue;
  }

  set(
    documentWithNewValue,
    `parseur_result.${keyWithoutGroup}`,
    formattedNewValue
  );

  return [documentWithNewValue, formattedNewValue];
};

export const getOriginalFieldValue = (key, document) => {
  const parseurResult = JSON.parse(JSON.stringify(document.parseur_result));

  const originalValue = findValue(parseurResult, key);

  return originalValue;
};
